import { ISSUE_REPORT_OFFER_STRINGS } from '@/lib/constants/issue-report';

export interface ComingSoonBadgeProps {
  /** `md` matches a primary button's box (a CMS or page CTA); `sm` fits the navbar and cards. */
  size?: 'sm' | 'md';
  /** For the dark navbar, where the light fill would glare. */
  onDark?: boolean;
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<ComingSoonBadgeProps['size']>, string> = {
  md: 'rounded-button px-8 py-4',
  sm: 'rounded-button px-4 py-2 text-sm',
};

// Contrast measured against the tinted fill: teal on the light fill is 10.4:1;
// slate on the dark bar's fill is 6.0:1 (slate on the light fill was only 2.1:1).
const TONE_CLASSES = {
  light: 'bg-slate/10 text-teal',
  dark: 'bg-white/10 text-slate',
} as const;

/**
 * The non-clickable "Coming Soon" state that replaces an Issue Report buy
 * action while no Issue Report plan is active (FR-203, MYN-285). A plain
 * `span`, deliberately not a disabled button or link: there is nothing to
 * press, focus or announce as an action, and the same element serves the
 * navbar, the dashboard card, the Data Room explainer, the purchase page and
 * the public Due Diligence page, so they cannot word or style it differently.
 */
export function ComingSoonBadge({ size = 'md', onDark = false, className = '' }: ComingSoonBadgeProps) {
  return (
    <span
      className={`inline-flex w-fit cursor-default select-none items-center font-medium ${SIZE_CLASSES[size]} ${
        TONE_CLASSES[onDark ? 'dark' : 'light']
      } ${className}`.trim()}
    >
      {ISSUE_REPORT_OFFER_STRINGS.COMING_SOON}
    </span>
  );
}
